import { DraftConfigurationTextStyle, Size } from '@/types';
import { nanoid } from '@/utils/nanoid';
import { SVG_NS, XLINK_NS } from './consts';
import { getMeasurer } from './getMeasurer';
import { getTextPathShape } from './getTextPathShape';

export const getBendingTextSizeForStyle = (
  style: DraftConfigurationTextStyle,
  text: string
): Size => {
  const svg = getMeasurer();
  const font = style.font;

  const pathId = nanoid();
  const path = document.createElementNS(SVG_NS, 'path');
  path.setAttribute('id', pathId);
  path.setAttribute('fill', 'none');
  path.setAttribute('d', getTextPathShape(style.angle));
  svg.appendChild(path);

  const textElement = document.createElementNS(SVG_NS, 'text');
  textElement.setAttribute('font-size', String(style.fontSize));
  textElement.setAttribute('font-family', font.identifier);
  textElement.setAttribute('font-style', font.style);
  textElement.setAttribute('font-weight', font.weight);
  textElement.setAttribute('text-anchor', 'middle');
  textElement.setAttribute('dy', style.angle < 0 ? '16' : '0');
  svg.appendChild(textElement);

  const textPath = document.createElementNS(SVG_NS, 'textPath');
  textPath.setAttributeNS(XLINK_NS, 'xlink:href', `#${pathId}`);
  textPath.setAttribute('startOffset', '50%');
  textPath.textContent = text;
  textElement.appendChild(textPath);

  const textBBox = textElement.getBBox();

  svg.removeChild(path);
  svg.removeChild(textElement);

  return {
    width: textBBox.width,
    height: textBBox.height,
    unit: 'mm',
  };
};
